import { forwardRef } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'

type Size = 'sm' | 'md'
type Variant = 'default' | 'toolbar'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'onChange' | 'prefix'> {
  value?: string
  onChange?: (next: string) => void
  size?: Size
  variant?: Variant
  block?: boolean
  loading?: boolean
  error?: boolean
  leadingIcon?: ReactNode
  trailingIcon?: ReactNode
  wrapperClassName?: string
}

export const TextInput = forwardRef<HTMLInputElement, Props>(function TextInput(
  { value, onChange, size = 'md', variant = 'default', block = false, loading = false, error = false, leadingIcon, trailingIcon, disabled, className, wrapperClassName, ...rest },
  ref,
) {
  const wrapperClasses = [
    'dsIn',
    block ? 'dsIn--block' : '',
    size !== 'md' ? `dsIn--${size}` : '',
    variant !== 'default' ? `dsIn--${variant}` : '',
    disabled || loading ? 'is-disabled' : '',
    error ? 'is-error' : '',
    loading ? 'is-busy' : '',
    wrapperClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={wrapperClasses}>
      {leadingIcon && <span className="dsIn__slot dsIn__slot--lead" aria-hidden="true">{leadingIcon}</span>}
      <input
        ref={ref}
        type={rest.type ?? 'text'}
        className={`dsIn__field ${className ?? ''}`.trim()}
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        disabled={disabled || loading}
        {...rest}
      />
      {trailingIcon && <span className="dsIn__slot dsIn__slot--trail" aria-hidden="true">{trailingIcon}</span>}
    </span>
  )
})
